module.exports = __webpack_public_path__ + "static/media/-_performance management.011e248e.png";